import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'

import Faq from '@/page/faq'
import TermsAndCondition from '@/page/termsAndCondition'
import Login from '@/page/Login'
import Sub from '@/page/sub'
import otp from '@/page/otp'
import Errors from '@/page/errors'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
		path: '/',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
    },
    {
		path: '/otp',
		name: 'otp',
		component: otp,
		meta: {
			title: 'otp'
		}
    },
    {
		path: '/sub',
		name: 'sub',
		component: Sub,
		meta: {
			title: 'Subscribe'
		}
    },{
      path: '/faq',
      name: 'faq',
      component: Faq,
      meta: {
        title: 'faqs'
      }
    },{
      path: '/termsAndCondition',
      name: 'termsAndCondition',
      component: TermsAndCondition,
      meta: {
        title: 'Terms and Condition'
      }
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
      meta: {
        title: 'errors'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js